import {Loaders} from "./LoaderStyle";

const Loader = () => {
    return (
       <Loaders>

           <div className="load"></div>

       </Loaders>
    );
};

export default Loader;
